import styled from 'styled-components';
// import { SubmitButton } from 'formik-antd';
import { Button } from 'antd';

export type PropsButtons = {
  disabled?: boolean;
  loading?: boolean;
};

export default styled(Button)<PropsButtons>`
  border-radius: 4px;
  height: 40px;
  min-width: 160px;
  line-height: 21px;
  &.ant-btn-primary {
    background: linear-gradient(149.45deg, #3c82c0 0%, #1c4b8c 100%);
    color: var(--white);
    border: unset;
    font-weight: 600;
  }
  &:disabled {
    border: 1px solid #cccccc !important;
    color: #808080 !important;
    font-weight: 600;
    background: unset;
  }
`;
